import React from 'react';
import { StrategyAssignmentPopover } from '../../modals/data-uploader/views/components/StrategyAssignmentPopover';
import { useAllocationSearch } from './AllocationSearchContext';
import { createPortal } from 'react-dom';

interface AllocationSearchStrategyViewProps {
  nodeRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
}

export const AllocationSearchStrategyView: React.FC<AllocationSearchStrategyViewProps> = ({ nodeRef, onClose }) => {
  const { selectedFundForStrategyAssignment, handleStrategySelected, handleBack } = useAllocationSearch();

  if (!selectedFundForStrategyAssignment) {
    return null;
  }

  const handleStrategySelect = (strategyId: string, strategyName: string) => {
    handleStrategySelected(strategyId, strategyName);
    onClose();
  };

  const boundingRect = nodeRef.current?.getBoundingClientRect();

  // TODO: Instead of reusing StrategyAssignmentPopover, create a new component specifically for strategy selection
  // and use the already available wrapper we have so we don't have to duplicate the position calculation and outer styling.
  return createPortal(
    <div className="fixed z-50 inset-0 pointer-events-none">
      <div
        className="fixed w-[700px] max-h-[500px]"
        style={boundingRect ? { top: boundingRect.bottom, left: boundingRect.left + 12 } : undefined}
      >
        <StrategyAssignmentPopover
          isOpen
          onOpenChange={(open) => {
            if (!open) {
              handleBack();
              onClose();
            }
          }}
          onStrategySelect={handleStrategySelect}
          investmentName={selectedFundForStrategyAssignment.name}
          disabled={false}
          isAnchored
          className="border border-solid border-venn-grey-30 w-[700px] h-[500px] p-0 rounded-[8px] shadow-[0_3px_6px_0_rgba(0,0,0,0.25)]"
        >
          <div />
        </StrategyAssignmentPopover>
      </div>
    </div>,
    document.body,
  );
};
